import { intervalToDuration, format } from 'date-fns';

export const getIntervalDurationInDays = (date: string) => {
  const duration = intervalToDuration({ start: new Date(date), end: new Date() });
  const formattedDate = format(new Date(date), 'yyyy-MM-dd');
  const formattedCurrentDate = format(new Date(), 'yyyy-MM-dd');

  if (duration.days === 0) {
    if (formattedDate === formattedCurrentDate) {
      return 0;
    }
    return 1;
  }
  return duration.days;
};
